export enum ImportDialogModeEnum {
  CONVERSION = 'CONVERSION',
  IMPORT = 'IMPORT',
}

export const IMPORT_DIALOG_MODES: ImportDialogModeEnum[] = [
  ImportDialogModeEnum.IMPORT,
  ImportDialogModeEnum.CONVERSION,
];
